import { uuid } from "@hex/common";
import { useState } from "react";

// returns unique id (uuid) valid for the
// duration of the component's lifecycle
export function useUniqueId(): string {
  const [id] = useState(() => uuid());
  return id;
}

/**
 * Returns the given id or generates a unique id that is
 * stable for the duration of the component's lifecycle.
 */
export function useId(defaultId?: string): string {
  const uniqueId = useUniqueId();
  return defaultId ?? uniqueId;
}
